<h1 mat-dialog-title i18n>Add Document</h1>
<div>
  <p i18n>To add a new document, complete the form below then click Submit.</p>

  <form #documentForm="ngForm" (ngSubmit)="saveDocument(documentForm)">
    <div class="form-group row">
      <label for="note_Text" class="col-sm-3 col-form-label" i18n>Description</label>
      <div class="col-sm-9">
        <textarea #documentNote name="note_Text" id="note_Text"
                  [(ngModel)]="data.document.note_Text" #note_Text="ngModel"
                  class="form-control" rows="3"></textarea>
      </div>
    </div>
    <div class="form-group row">
      <label for="attachment" class="col-sm-3 col-form-label" i18n>Attachment</label>
      <div class="col-sm-9">
        <div class="custom-file">
          <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="importFile"></app-file-upload>
          {{data.document.note_Attachment}}
        </div>
      </div>
    </div>
    <div class="mat-dialog-actions float-right">
      <div *ngIf="!isRequesting">
        <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
        <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
</form>
</div>
